import { FC } from 'react';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { isSuccess } from 'utils/responseStatus';

import { useDeleteContractorDriverPumpPriceMutation } from 'bus/contractorDriverPumpPrice/services';

type Props = {
  id: number;
  onRefresh: () => void;
};

export const DeleteContractorDriverPumpPriceModal: FC<Props> = ({ id, onRefresh }) => {
  const { hideModal } = useModal();

  const [deleteDriverPumpSalary, { isLoading }] = useDeleteContractorDriverPumpPriceMutation();

  const handleSubmit = () => {
    deleteDriverPumpSalary({ id }).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      onSubmit={handleSubmit}
      title="Удалить запись?"
      visible
      isLoadingSubmit={false}
      width={400}
      minHeight={130}
      textConfirm="Удалить"
      hideOnOutsideClick={false}
      disabledSubmit={isLoading}
      typeConfirm="danger"
    >
      <div>Подтвердите удаление</div>
    </ModalForm>
  );
};
